import { API_CONSTANT_MAP } from "./paths";
import requestApi from "./requestApi";

const BASE = API_CONSTANT_MAP.orcamentoPublico;

export type UnidadePublica = {
  id: number;
  nome: string;
  enderecoCompleto?: string | null;
};

export type TurmaPublica = {
  id: number;
  nome: string;
  periodoLetivo?: string | null;
  dataInicio?: string | null;
};

export type LinhaOrcamento = {
  codigo: string;
  disciplinaId: number;
  tipo: string;
  nome: string;
  valor: number;
  percDesconto: number;
  valorDesconto: number;
  valorFinal: number;
  selecionado: boolean;
  bloqueado: boolean;
  /** "RELACIONADA": específica travada por outra já escolhida. */
  motivoBloqueio?: string | null;
  selecionadoAutomaticamente: boolean;
};

export type ResultadoOrcamento = {
  turmaId: number;
  turmaNome: string;
  unidadeId: number;
  unidadeNome: string;
  linhas: LinhaOrcamento[];
  quantidadeEspecificas: number;
  percDescontoFaixa: number;
  /** Não há faixa cadastrada para a quantidade marcada: o desconto zerou. */
  semFaixaCadastrada: boolean;
  /** Monitorias recusadas que ainda valem — a tela substitui a lista dela por esta. */
  itensRecusados: string[];
  matriculaCodigo?: string | null;
  matriculaNome?: string | null;
  matriculaValor: number;
  totalBruto: number;
  totalDesconto: number;
  totalFinal: number;
};

export type SalvarOrcamentoResponse = {
  id: number;
  idOrcamento?: number | null;
  orcamento: ResultadoOrcamento;
};

/** Primeiro passo: grava o contato antes de o interessado escolher qualquer coisa. */
export const registrarInteresse = async (payload: {
  nome: string;
  email: string;
  celular: string;
}) => requestApi.postPublic(`${BASE}/interesse`, payload);

export const getUnidadesPublicas = async () =>
  requestApi.getPublic(`${BASE}/unidades`);

export const getTurmasPublicas = async (unidadeId: number) =>
  requestApi.getPublic(`${BASE}/unidades/${unidadeId}/turmas`);

/**
 * Catálogo da turma já calculado no servidor. Com `itens` vazio devolve a lista
 * sem desconto — é assim que a tela monta a tabela antes da primeira marcação.
 * A página não calcula nada: exibe o que vem daqui.
 */
export const simularOrcamento = async (payload: {
  unidadeId: number;
  turmaId: number;
  itens: string[];
  /** Monitorias que o usuário desmarcou depois de entrarem sozinhas. */
  itensRecusados: string[];
}) => requestApi.postPublic(`${BASE}/simular`, payload);

export const salvarOrcamentoPublico = async (payload: {
  interesseId?: number | null;
  nome: string;
  email: string;
  celular: string;
  unidadeId: number;
  turmaId: number;
  itens: string[];
  itensRecusados: string[];
  alunoNome: string;
}) => requestApi.postPublic(BASE, payload);
